import getWindow from '@loggi/js/get-window';
import isNumber from '@loggi/js/validators/is-only-numbers';

const $window = getWindow();
const DEFAULT_OBJECT = 'GoogleAnalyticsObject';
const DEFAULT_INSTANCE = 'ga';

const isTrackingObject = trackingData => {
  const isObject =
    typeof trackingData === 'object' && !Array.isArray(trackingData);
  const keys = isObject ? Object.keys(trackingData) : [];

  return (
    isObject && keys.includes('eventCategory') && keys.includes('eventAction')
  );
};

const resolveTrackingData = (category, action, callback) => {
  if (isTrackingObject(category)) {
    const {
      eventCategory,
      eventAction,
      eventLabel,
      eventValue,
      hitCallback
    } = category;

    const analyticsObj = {
      eventCategory,
      eventAction
    };

    if (eventLabel) {
      analyticsObj.eventLabel = eventLabel;
    }
    if (eventValue && isNumber(eventValue)) {
      analyticsObj.eventValue = eventValue;
    }
    if (hitCallback) {
      analyticsObj.hitCallback = hitCallback;
    }

    return analyticsObj;
  }

  return {
    eventCategory: category,
    eventAction: action,
    hitCallback: callback
  };
};

export default function googleAnalyticsLog(
  category,
  action,
  callback = () => {}
) {
  if (!$window) {
    return;
  }

  const instanceName = $window[DEFAULT_OBJECT] || DEFAULT_INSTANCE;
  const googleInstance = $window[instanceName];

  const trackingData = resolveTrackingData(category, action, callback);

  if (typeof googleInstance === 'function') {
    googleInstance('send', 'event', trackingData);
  }
}
